import axios from "axios";

import {
    DB,
    CONTACT_FORM_URL
} from "@/firebase";

class UserApi {
    // Source: https://developers.google.com/places/supported_types
    PLACE_TYPES = [
        "accounting",
        "airport",
        "amusement_park",
        "aquarium",
        "art_gallery",
        "atm",
        "bakery",
        "bank",
        "bar",
        "beauty_salon",
        "bicycle_store",
        "book_store",
        "bowling_alley",
        "bus_station",
        "cafe",
        "campground",
        "car_dealer",
        "car_rental",
        "car_repair",
        "car_wash",
        "casino",
        "cemetery",
        "church",
        "city_hall",
        "clothing_store",
        "convenience_store",
        "courthouse",
        "dentist",
        "department_store",
        "doctor",
        "electrician",
        "electronics_store",
        "embassy",
        "fire_station",
        "florist",
        "funeral_home",
        "furniture_store",
        "gas_station",
        "gym",
        "hair_care",
        "hardware_store",
        "hindu_temple",
        "home_goods_store",
        "hospital",
        "insurance_agency",
        "jewelry_store",
        "laundry",
        "lawyer",
        "library",
        "liquor_store",
        "local_government_office",
        "locksmith",
        "lodging",
        "meal_delivery",
        "meal_takeaway",
        "mosque",
        "movie_rental",
        "movie_theater",
        "moving_company",
        "museum",
        "night_club",
        "painter",
        "park",
        "parking",
        "pet_store",
        "pharmacy",
        "physiotherapist",
        "plumber",
        "police",
        "post_office",
        "real_estate_agency",
        "restaurant",
        "roofing_contractor",
        "rv_park",
        "school",
        "shoe_store",
        "shopping_mall",
        "spa",
        "stadium",
        "storage",
        "store",
        "subway_station",
        "supermarket",
        "synagogue",
        "taxi_stand",
        "train_station",
        "transit_station",
        "travel_agency",
        "veterinary_care",
        "zoo",
    ];

    getWorkById(workId) {
        return DB.collection("works")
            .doc(workId)
            .get()
            .then(data => {
                const placeMetadata = data.get('placeMetadata');

                return {
                    title: data.get("title"),
                    embedCode: data.get("embedCode"),
                    previewSrc: data.get('previewSrc'),
                    previewImageURL: data.get("previewImageURL"),
                    placeMetadata: {
                        vicinity: placeMetadata.vicinity,
                        place_id: placeMetadata.place_id,
                        name: placeMetadata.name
                    }
                };
            });
    }

    getWorkUnlistedDataById(workId, unlistedDataId) {        
        return DB.collection('works').doc(workId).collection('unlisted').doc(unlistedDataId)
            .get()
            .then(doc => {
                return {
                    items: doc.data()['items']
                };
            });
    }

    getMainPageWorks(limit) {
        return DB.collection("works")
            .where("showOnMainPage", "==", true)
            .orderBy("panoMetadata.date", "desc")
            .limit(limit)
            .get()
            .then(querySnapshot => {
                return querySnapshot.docs.map(work => {
                    return {
                        title: work.data()["title"],
                        previewImageURL: work.data()["previewImageURL"],
                        id: work.id
                    };
                });
            });
    }

    getWorksByPlaceTypes(placeTypes) {
        const promises = [];
        // At most 5 placeTypes are allowed.
        for (let pt of placeTypes.slice(0, 5)) {
            if (this.PLACE_TYPES.indexOf(pt) === -1) {
                continue;
            }

            // Compound queries with OR are not alloed. We have to make
            // multiple queries and merge the result.
            const p = DB.collection("works")
                .where('placeMetadata.types', 'array-contains', pt)
                .get()
                .then(querySnapshot => {
                    return querySnapshot.docs.map(work => {
                        return {
                            date: work.data()['date'],
                            title: work.data()["title"],
                            previewImageURL: work.data()["previewImageURL"],
                            id: work.id
                        };
                    });    
                });
            promises.push(p);
        }
        return Promise.all(promises).then(results => {
            const worksDict = {};
            for (const r of results) {
                for (const w of r) {
                    worksDict[w.id] = w;
                }
            }

            const worksList = Object.values(worksDict);
            worksList.sort((a, b) => b.timestamp - a.timestamp);
            return worksList;
        });
    }

    sendContactForm(formData) {
        return axios.post(CONTACT_FORM_URL, formData);
    }
}

const USER_API = new UserApi();
// Needed for Cypress testing.
window.USER_API = USER_API;

export default USER_API;